<div class="metric-detail-lines-container">
  <!-- More Details Button -->
  @if (showMoreDetailsButton) {
<div class="more-details-section">
    <button
      nbButton
      ghost
      status="primary"
      size="small"
      (click)="onMoreDetailsClick()"
    >
      <nb-icon icon="bar-chart-outline"></nb-icon>
      More Details
    </button>
  </div>
}

  <!-- Header section for additional components -->
  <div class="header-section">
    <ng-content select="[header]"></ng-content>
  </div>

  <!-- KPI Tiles Section - displays book value sum per queue -->
  @if (showKpiCards && queueKpiCards.length > 0) {
    <div class="kpi-tiles-row">
      @for (card of queueKpiCards; track card) {
        <div class="kpi-tile kpi-tile-success">
          <div class="kpi-tile-icon">
            <i class="fa-solid fa-dollar-sign"></i>
          </div>
          <div class="kpi-tile-content">
            <div class="kpi-tile-value">
              @if (!card.isLoading) {
                <span>{{ card.queueName }}</span>
              }
              @if (card.isLoading) {
                <i class="fa-solid fa-spinner fa-spin"></i>
              }
            </div>
            <div
              class="kpi-tile-title"
              [nbTooltip]="formatCurrency(card.bookValueSum)"
              nbTooltipPlacement="top"
              >
              {{ formatCurrencyCompact(card.bookValueSum) }}
            </div>
            <div class="kpi-tile-subtitle">Book Value</div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Dynamic List View -->
  <div class="list-view-section">
    <next-object-list
      #objectList
      [object]="object"
      [filters]="filters"
      [hideQueues]="false"
      [hideToolBar]="false"
      [height]="500"
      [showDetailOnDoubleClick]="false"
      [customDoubleClickHandler]="onRowDoubleClick.bind(this)"
      (queuesLoaded)="onQueuesLoaded($event)"
      [page]="page"
    ></next-object-list>
  </div>

  <!-- Footer section for additional components -->
  <div class="footer-section">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
